import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DietaryRestriction } from "../../../../../__generated__/graphql";

type DietsTableProps = {
  diets: DietaryRestriction[];
};
export default function DietsTable({ diets }: DietsTableProps) {
  return (
    <Table sx={{ width: "unset" }} size="small">
      <TableHead>
        <TableRow>
          {["Dietary Request", "Availability"].map((header) => (
            <TableCell key={header} sx={{ paddingTop: 0, paddingBottom: 0 }}>
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {diets.map(({ diet, isPossible }) => (
          <TableRow
            key={diet}
            sx={{
              "&:last-child td, &:last-child th": {
                border: 0,
                paddingBottom: 0,
              },
            }}
          >
            <TableCell>
              <Typography>{diet}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{isPossibleDetails[isPossible]}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

const isPossibleDetails = {
  yes: "✓ possible",
  limited: "△ limited",
  no: "✕ unavailable",
} as const;
